/**
 * @generated SignedSource<<86f6cb0c52b1939e6e37196af41b221e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueStatsTopTypes_IssueStats$data = {
  readonly topIssueTitles: ReadonlyArray<{
    readonly count: number;
    readonly title: string | null;
  }>;
  readonly " $fragmentType": "IssueStatsTopTypes_IssueStats";
};
export type IssueStatsTopTypes_IssueStats$key = {
  readonly " $data"?: IssueStatsTopTypes_IssueStats$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueStatsTopTypes_IssueStats">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueStatsTopTypes_IssueStats",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueStatTitleCountNode",
      "kind": "LinkedField",
      "name": "topIssueTitles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IssueStats",
  "abstractKey": null
};

(node as any).hash = "38a654f89000e985e89a9558d67ab4b0";

export default node;
